import { createContext, useContext } from 'react';

// Flutter's TickerMode for keep-mounted panes: false inside tab panes that are
// not selected, under an overlay, or covered by a pushed page or modal layer.

export const PaneActiveContext = createContext(true);

/** True while the screen containing the caller is the one the user sees. Pause polling/animations otherwise. */
export function usePaneActive(): boolean {
  return useContext(PaneActiveContext);
}

/**
 * Desktop layout: true inside an overlay (Statistics, Reading List,
 * Connections), which the sidebar opens like a tab, so its screen shows no
 * Back button. False on phones, where overlays push over the Menu tab, and in
 * pushed pages.
 */
export const SidebarDestinationContext = createContext(false);

export function useSidebarDestination(): boolean {
  return useContext(SidebarDestinationContext);
}
